import React from 'react';
import { iconSizer } from "../../../../internal/icons2022/iconSizer";
import { NetUploadIcon16Light } from "../../../../internal/icons2022/NetUploadIcon/NetUploadIcon16Light";
import { NetUploadIcon20Light } from "../../../../internal/icons2022/NetUploadIcon/NetUploadIcon20Light";
import { NetUploadIcon24Regular } from "../../../../internal/icons2022/NetUploadIcon/NetUploadIcon24Regular";
export var UploadIcon = iconSizer({
  small: function small() {
    return /*#__PURE__*/React.createElement(NetUploadIcon16Light, null);
  },
  medium: function medium() {
    return /*#__PURE__*/React.createElement(NetUploadIcon20Light, null);
  },
  large: function large() {
    return /*#__PURE__*/React.createElement(NetUploadIcon24Regular, null);
  }
}, 'UploadIcon');